// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".homepage .recently-viewed-campsites.desktop{margin:0 auto;max-width:var(--page-width-max);width:100%}.homepage .recently-viewed-campsites.desktop h3{font-size:3em;font-weight:700;margin:0 auto;padding:1em var(--page-width-padding);text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
